import axios from "./axios"; //引入axios
import router from "../router";
import {
  MessageBox,
  Message
} from 'element-ui'

const service = axios.create({
  headers: {
    //请求头
    get: {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
      // 在开发中，一般还需要单点登录或者其他功能的通用请求头，可以一并配置进来
    },
    post: {
      "Content-Type": "application/json",
      // 在开发中，一般还需要单点登录或者其他功能的通用请求头，可以一并配置进来
    },
  },
  settimeout: 50000, //超时时间
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么 验证token之类的
    if (localStorage.getItem("token")) {
      // config.headers.token = window.localStorage.getItem("token");
      config.headers.Authorization = 'Bearer ' + localStorage.getItem("token");
      // localStorage.removeItem("userInfo");
      //   console.log(localStorage.getItem("token"));
      //   console.log("存入的token",token);
      //   console.log("config请求的数据:", config.headers.token);
    }
    return config; //记得一定要 返回config
  },
  (error) => {
    // 对请求错误做些什么
    console.log("error请求的数据:", error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // console.log("返回的数据", response);
    // 这里拦截401错误，并重新跳入登页重新获取token
    // 后面还能继续判断code
    if (response.status && response.status === 200) {
      // 通讯成功
      if (response.data.success) {
        if (response.data.code === 0) {
          return response.data;
        } else if (response.data.code == 401) {
          // 如果是token过期，跳转至登录
          // console.log("登录过期");
          // console.log("清除token");
          // localStorage.removeItem("token"); // 移除token，跳转至登录
          localStorage.clear();
          sessionStorage.clear();
          // alert("请重新登录!");
          router.push({
            path: '/',
            query: {
              redirect: router.currentRoute.fullPath
            } // 将当前路由作为参数传递，以便登录后可以重定向回来
          });
          location.reload();
        }
        return Promise.resolve(response.data);
      } else {
        var number = response.data.code;
        console.log(number);
        return Promise.resolve(response.data);
      }
    }
  },
  (error) => {
    console.log(error.status);
    if (error.status === 401) {
      MessageBox.confirm('登录状态已失效，请重新登录', '确认登出', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 清除token
        localStorage.removeItem('token');
        // 跳转到登录页面
        router.push({
          path: '/',
          query: {
            redirect: router.currentRoute.fullPath
          } // 将当前路由作为参数传递，以便登录后可以重定向回来
        });
      }).catch(() => {
        // 取消操作
      });
      // localStorage.removeItem('token');
      // localStorage.clear();
      // sessionStorage.clear();
      // console.log(error.status,'*******');
      // // router.replace({ path: "/user" });
      // router.push({
      //   path: '/',
      //   query: { redirect: router.currentRoute.fullPath } // 将当前路由作为参数传递，以便登录后可以重定向回来
      // });
      // location.reload();
      // windows.$router.replace("/");
    }
    // 对响应错误做点什么
    return Promise.reject(error);
    // return Promise.resolve(error);
  }
);
export default service;



// WEBPACK FOOTER //
// ./src/request/request.js